/* Atelier Elemental -- T-527 N1: one-tap "add the cheapest vial that
 * crosses free shipping" button. Self-contained (does not touch
 * ae-gift-autoadd.js). Container + its data attributes are rendered fresh
 * by snippets/ae-nudge-cart.liquid on every cart render (Section Rendering
 * API swap), so this script always reads the CURRENT true remaining/
 * threshold off the DOM rather than caching a stale value.
 *
 * Cart-write rules followed (see memory shopify-cart-line-keys):
 *   - variant id sent as a STRING to /cart/add.js, never numeric or cached.
 *   - never persists a cart line "key" across a write.
 *   - busy guard + re-schedule, same shape as ae-gift-autoadd.js.
 *   - re-reads /cart.js as truth after every write; never assumes success
 *     from the add.js response's echoed line alone.
 *   - if the cheapest candidate fails (e.g. sold out), retries the next
 *     cheapest candidate that still crosses the remaining gap, once each,
 *     before giving up and showing nothing (fail closed, never a stuck or
 *     misleading button).
 */
(function () {
  var BESTSELLERS_URL = window.__AE_NUDGE_BESTSELLERS_URL || null;
  var STRINGS = { en: {}, fr: {} };
  try { STRINGS = window.__AE_NUDGE_STRINGS || STRINGS; } catch (e) {}

  var busy = false, scheduled = false, bestsellersCache = null, bestsellersPromise = null;

  function getJSON(u, o) {
    return fetch(u, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, o || {})).then(function (r) {
      if (!r.ok) { var err = new Error('HTTP ' + r.status); err.status = r.status; throw err; }
      return r.json();
    });
  }

  function money(cents, fr) {
    var amount = cents / 100;
    try {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
      var locale = fr ? 'fr-CA' : 'en-CA';
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: 2 }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function loadBestsellers() {
    if (bestsellersCache) return Promise.resolve(bestsellersCache);
    if (bestsellersPromise) return bestsellersPromise;
    if (!BESTSELLERS_URL) return Promise.resolve(null);
    bestsellersPromise = getJSON(BESTSELLERS_URL).then(function (data) {
      bestsellersCache = data;
      return data;
    }).catch(function () { return null; });
    return bestsellersPromise;
  }

  function refreshSections() {
    var ids = [];
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
      if (/cart|drawer|bubble/i.test(el.id)) ids.push(el.id.replace('shopify-section-', ''));
    });
    var done = function () {
      ['cart:refresh', 'cart:updated', 'cart-drawer:refresh'].forEach(function (n) {
        document.dispatchEvent(new CustomEvent(n, { bubbles: true }));
      });
    };
    if (!ids.length) return done();
    return fetch('/?sections=' + ids.join(',')).then(function (r) { return r.json(); }).then(function (data) {
      ids.forEach(function (id) {
        var host = document.getElementById('shopify-section-' + id);
        if (host && data[id]) {
          var doc = new DOMParser().parseFromString(data[id], 'text/html');
          var fresh = doc.getElementById('shopify-section-' + id);
          if (fresh) host.innerHTML = fresh.innerHTML;
        }
      });
      done();
    }).catch(done);
  }

  function addVariant(variantIdString) {
    return getJSON('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: variantIdString, quantity: 1 }] }),
    });
  }

  // Try candidates in order (cheapest-that-crosses first); on failure (sold
  // out / any error) move to the next. Never invents a fake success.
  function addWithFallback(candidates, idx) {
    idx = idx || 0;
    if (idx >= candidates.length) return Promise.reject(new Error('no candidate available'));
    var c = candidates[idx];
    return addVariant(String(c.variantId)).catch(function () {
      return addWithFallback(candidates, idx + 1);
    });
  }

  function pickCandidates(list, remainingCents, pricePct) {
    // 2026-10-15: remainingCents is fragrance still needed AFTER discounts
    // (snippets/ae-nudge-cart.liquid); a candidate counts at pricePct% of its
    // list price, so it must still cross the gap once discounted.
    var pct = (pricePct > 0 && pricePct <= 100) ? pricePct : 100;
    // Cheapest bestseller whose price alone crosses the remaining gap,
    // ascending, so a sold-out cheapest one falls through to the next
    // cheapest that STILL crosses -- never jumps to the most expensive item.
    return (list || [])
      .filter(function (item) { return Math.floor(Number(item.price) * pct) >= remainingCents; })
      .sort(function (a, b) { return Number(a.price) - Number(b.price); });
  }

  function render(container, remainingCents, fr, pricePct) {
    var slot = container.querySelector('[data-ae-nudge-suggestion]');
    if (!slot) return;
    loadBestsellers().then(function (data) {
      var candidates = pickCandidates(data && data.items, remainingCents, pricePct);
      if (!candidates.length) { slot.innerHTML = ''; return; }
      var pick = candidates[0];
      var t = (fr ? STRINGS.fr : STRINGS.en) || {};
      var label = (t.n1_add_button || 'Add %%title%% (%%price%%) to reach free shipping')
        .replace('%%title%%', pick.title)
        .replace('%%price%%', money(Math.round(Number(pick.price) * 100), fr));
      slot.innerHTML = '<button type="button" class="ae-nudge-cart__suggestion-button" data-ae-nudge-add data-variant-id="' + pick.variantId + '">' + label + '</button>';
      var btn = slot.querySelector('[data-ae-nudge-add]');
      btn.addEventListener('click', function () {
        if (busy) return;
        busy = true;
        btn.disabled = true;
        addWithFallback(candidates, 0).then(function () {
          return refreshSections();
        }).then(function () {
          busy = false;
        }).catch(function () {
          busy = false;
          var errT = (t.n1_add_error || 'Could not add that automatically. Add it from its product page instead.');
          slot.innerHTML = '<p class="ae-nudge-cart__suggestion-note">' + errT + '</p>';
        });
      });
    });
  }

  function evaluate() {
    if (busy) { scheduled = true; return; }
    document.querySelectorAll('[data-ae-nudge-n1]').forEach(function (container) {
      var remainingCents = Number(container.getAttribute('data-remaining-cents')) || 0;
      var fr = container.getAttribute('data-fr') === 'true';
      var pricePct = Number(container.getAttribute('data-price-pct')) || 100;
      if (remainingCents > 0) render(container, remainingCents, fr, pricePct);
      else { var slot = container.querySelector('[data-ae-nudge-suggestion]'); if (slot) slot.innerHTML = ''; }
    });
    if (scheduled) { scheduled = false; setTimeout(evaluate, 40); }
  }

  function schedule() { clearTimeout(schedule._t); schedule._t = setTimeout(evaluate, 150); }

  var _fetch = window.fetch;
  window.fetch = function () {
    var args = arguments, url = (args[0] && args[0].url) || args[0];
    var p = _fetch.apply(this, args);
    try { if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) p.then(schedule, function () {}); } catch (e) {}
    return p;
  };
  var _open = window.XMLHttpRequest && XMLHttpRequest.prototype.open;
  if (_open) {
    XMLHttpRequest.prototype.open = function (m, u) {
      try { if (typeof u === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(u)) this.addEventListener('load', schedule); } catch (e) {}
      return _open.apply(this, arguments);
    };
  }

  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart-drawer:refresh', schedule);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  window.addEventListener('pageshow', schedule);
})();
